<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g clip-path="url(#clip0_7_870)">
            <path d="M7.99989 12.4519L0.637939 5.08996L2.17972 3.54818L7.99989 9.36838L13.8201 3.54818L15.3618 5.08996L7.99989 12.4519Z" fill="#F5F5F5"/>
        </g>
        <defs>
            <clipPath id="clip0_7_870">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>